/* eslint-disable react/forbid-prop-types */
import { forwardRef } from 'react';
import P from 'prop-types';
import { Dialog, Toolbar, IconButton, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { StyledAppBar } from './styles';
import { IsCorujaFlow, IsRdgoFlow, IsRbmFlow } from '../../service/flow.service.ts';
import { maskDateTime } from '../../utils/masks';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function FullScreenDialog({ open, setOpen, lead, children, channelName }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition}>
      <StyledAppBar style={{backgroundColor: 'rgb(250 156 18)'}}>
        <div className='leadId'>
          Lead: <b>{lead?.id}</b> | Canal: <b>{channelName}</b>
          {lead?.canceled_at && 
            (<> | <canceled> Lead Cancelado em: <b>{maskDateTime(lead.canceled_at)}</b></canceled></>)
          }
        </div>
        <Toolbar style={{display: 'flex', justifyContent: 'flex-end', minHeight: '30px'}}>
          {IsCorujaFlow() || IsRdgoFlow() || IsRbmFlow() ? (
          <span className='tenantId'>
            {localStorage.getItem("tenantId")?.toLowerCase()}
          </span>
          ) : null }  
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close" size="small">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </StyledAppBar>
      <div style={{marginTop: '50px', position: 'relative', backgroundColor: '#e7e7e7'}}>
      {children}
      </div>
    </Dialog>
  );
}

FullScreenDialog.propTypes = {
  open: P.bool.isRequired,
  children: P.node.isRequired,
  setOpen: P.func.isRequired,
  lead: P.object,
  channelName: P.string,
};

FullScreenDialog.defaultProps = {
  lead: null,
  channelName: null,
}